<div class="select-search-wrapper" ng-if="$ctrl.editable">
    <c-dropdown-table-select  watermark="$ctrl.searchWatermark" items="$ctrl.lookupItems" searching="$ctrl.searching" callback="$ctrl.callback" hide-headers="$ctrl.hideHeaders"></c-dropdown-table-select>
</div>
<c-simple-list configuration="$ctrl.nodeListConfig" items="$ctrl.nodeItems"></c-simple-list>
